var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ax-head-box"},[_c('div',{staticClass:"head_content"},[_c('div',{staticClass:"ing_box"},[_vm._t("ing")],2),_c('div',{staticClass:"over_box"},[_vm._t("over")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }